export default __webpack_public_path__ + "images/fj-f3d86add9fe9ed6722749f8a0f21fc1d.svg";